import { getLocalData, setLocalData } from 'complex-utils'

export interface LoadControlItemInitOption<D = any>{
  offset: number
  priority: number
  local: string
  check: (initData?: D) => boolean
  load: () => Promise<{ status: string, data: D }>
  init: (initData: D) => void
}

export class LoadControlItem<D = any> {
  offset: number
  priority: number
  local: string
  check: (initData?: D) => boolean
  load: () => Promise<{ status: string, data: D }>
  init: (initData: D) => void
  constructor(initOption: LoadControlItemInitOption<D>) {
    this.offset = initOption.offset
    this.priority = initOption.priority
    this.local = initOption.local
    this.check = initOption.check
    this.load = initOption.load
    this.init = initOption.init
  }
  getLocal(): undefined | D {
    // return getLocalData(this.local) as undefined | D
    return undefined
  }
  setLocal(value: any) {
    return setLocalData(this.local, value)
  }
  trigger(init?: boolean): Promise<{ status: string, data: D }> {
    const initData = this.getLocal()
    if (initData && this.check(initData) && init) {
      // 已加载且当前为初始化加载时，直接set设置值，否则则需要进行获取数据操作
      setTimeout(() => {
        this.trigger()
      }, this.offset)
      this.init(initData)
      return Promise.resolve({ status: 'loaded', data: initData })
    } else {
      return new Promise((resolve, reject) => {
        this.load().then((res) => {
          this.init(res.data)
          this.setLocal(res.data)
          resolve(res)
        }).catch(reject)
      })
    }
  }
}

class LoadControl {
  data: Record<string, LoadControlItem>
  constructor() {
    this.data = {}
  }

  pushControl(key: string, value: LoadControlItemInitOption) {
    const item = new LoadControlItem(value)
    this.data[key] = item
    return item.trigger(true)
  }
}

export default LoadControl
